/**
 * Call to Action - Create Group
 * -----------------------------
 * Shows a simple message prompting the user to create a group if the list of groups shown
 * does not contain the one they are looking for. Could be used for group search results
 * or at the end of the entire list of groups.
 *
 * Expected variables: none
 */

import View from 'view/view'
import template from 'component/cta/create_group/template.tmpl'
import Router from 'service/router'
import dataProvider from 'service/data_provider'
import assets from 'service/assets'

const CreateGroupView = View.extend({
    template,
    render() {
        this.$el.html(
            this.template({
                img: assets.getStaticImageUrl('/ui/empty-states/no-groups-v1.svg'),
                isLoggedIn: Boolean(dataProvider.get('currentUser')),
                link: {
                    createGroup: Router.path('about_get_involved_index', null, { query: { ref: 'gro_sb_btn' } }),
                    learnMore: Router.path('about_get_involved_index', null, {
                        query: { ref: 'gro_sb_con' },
                    }),
                },
            })
        )

        return this
    },
})

export default CreateGroupView
